import React from "react";
import { Box, Container, Link, Typography } from "@mui/material";

export default function Footer() {
  const links = [
    { href: "/", label: "Home" },
    { href: "/companies", label: "Companies" },
    { href: "/rankings", label: "Rankings" },
    { href: "/screener", label: "Screener" },
    { href: "/about", label: "About" },
    { href: "/contact", label: "Contact" },
    { href: "/privacy", label: "Privacy" },
    { href: "/terms", label: "Terms" },
    { href: "#cookie-preferences", label: "Cookie Preferences", onClick: "cookie-preferences" },
  ];
  const year = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: "background.paper",
        borderTop: "1px solid rgba(0,0,0,0.08)",
        py: 3,
      }}
    >
      <Container maxWidth={false} sx={{ maxWidth: 1440 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", sm: "center" },
            gap: 2,
            mb: 1,
          }}
        >
          <Typography variant="body2" color="text.secondary">
            © {year} Mining Directory. All rights reserved.
          </Typography>
          <Box
            sx={{
              display: { xs: "grid", sm: "flex" },
              gridTemplateColumns: { xs: "repeat(4, minmax(0,1fr))" },
              columnGap: { xs: 1, sm: 2 },
              rowGap: { xs: 1, sm: 0 },
              justifyContent: { sm: "flex-end" },
              width: { xs: "100%", sm: "auto" },
            }}
          >
            {links.map((link) => (
              <Link
                key={link.label}
                href={link.onClick ? undefined : link.href}
                underline="hover"
                color="inherit"
                variant="body2"
                component={link.onClick ? "button" : "a"}
                onClick={
                  link.onClick
                    ? (event) => {
                        event.preventDefault();
                        window.dispatchEvent(new CustomEvent(link.onClick));
                      }
                    : undefined
                }
                sx={{
                  textAlign: { xs: "center", sm: "left" },
                  minWidth: { xs: 0, sm: "unset" },
                  background: "none",
                  border: "none",
                  padding: 0,
                  cursor: link.onClick ? "pointer" : "inherit",
                }}
              >
                {link.label}
              </Link>
            ))}
          </Box>
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6, pt: 2, maxWidth: "600px" }}>
          ResourceNAV is not finanical advice. Ratings and information on this site are drawn from publicly available information, and
          the companies themselves. Please see our full Financial Disclaimer{" "}
          <Link
            href="https://naturalresourcestocks.net/financial-disclaimer-for-galt-consulting-group-dba-naturalresourcestocks-net/"
            underline="hover"
            color="inherit"
            target="_blank"
            rel="noopener noreferrer"
          >
            here
          </Link>
          .
        </Typography>
      </Container>
    </Box>
  );
}
